/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextInfo, {
  COLOR,
  FONT_TYPE,
  SIZE,
  SEGMENT,
  ALIGN,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import Slider from 'react-slick';
import Arrow from '@bit/gerenciatd.unifiedcomponents.arrow';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import SvgIconLoader, { SVG_ICON_KIND } from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import { CHEURON_TYPES } from '@bit/gerenciatd.unifiedicons.cheuron';
import { getUrlAlias } from '../../utils/url.utils';

import './SubHeader.scss';

export const COMPONENT_NAME = 'SubHeader';

export const FEATURES_SOLUCIONES_INDEX = {
  'soluciones-digitales': 0,
  ciberseguridad: 1,
  'conectividad-wifi': 2,
  teletrabajo: 3,
  'comercio-electronico': 4,
  'experiencia-cliente': 5,
  cloud: 6,
  'gestion-negocio': 7,
  'big-data-iot': 8,
}

const originalResponsive = [
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 8,
      slidesToScroll: 8,
    },
  },
  {
    breakpoint: 1100,
    settings: {
      slidesToShow: 7,
      slidesToScroll: 7,
    },
  },
  {
    breakpoint: 900,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6,
    },
  },
  {
    breakpoint: 860,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  },
  {
    breakpoint: 620,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 470,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  },
  {
    breakpoint: 330,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
  },
];

class SubHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      width: window.innerWidth,
      iconIndex: undefined,
      settings: {
        accessibility: true,
        arrows: false,
        slide: 'div',
        dots: false,
        draggable: false,
        infinite: false,
        speed: 500,
        slidesToShow: 9,
        slidesToScroll: 1,
        variableWidth: false,
        beforeChange: this.beforeChange,
        afterChange: this.afterChange,
        responsive: originalResponsive,
      },
    }
  }

  componentDidMount() {
    const indexToFeature = this.indexToFeature();
    if (Number.isInteger(indexToFeature)) {
      this.setState({
        iconIndex: indexToFeature,
      })
    }
    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    const indexToFeature = this.indexToFeature();
    if (prevState.iconIndex !== indexToFeature) {
      this.setState({
        iconIndex: indexToFeature,
      })
    }
    if (!this.state.checkParam && this.slider && Number.isInteger(this.indexToFeature())) {
      this.slideGoTo(this.state.iconIndex - this.findBreak() + 1);
      this.setState(state => ({
        checkParam: true,
        page: state.iconIndex - this.findBreak() + 1 > 0 ? state.iconIndex - this.findBreak() + 1 : 0,
      }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  beforeChange = (oldIndex, newIndex) => {
    if (oldIndex !== newIndex) {
      this.setState({ page: newIndex });
    }
  }

  findBreak = () => {
    const { width, settings } = this.state;
    const widthSlider = width;
    let slides = 2;
    let i = 0;
    let finish = false;

    while (i < settings.responsive.length && !finish) {
      if (settings.responsive[i].breakpoint <= widthSlider) {
        finish = true;
        if (i > 0) {
          slides = settings.responsive[i - 1].settings.slidesToShow;
        } else {
          slides = settings.slidesToShow;
        }
      } else {
        i += 1;
      }
    }
    return slides;
  }

  slideGoTo = (page) => {
    this.slider.slickGoTo(page);
  };

  slideToPrev = () => {
    this.slider.slickPrev();
  }

  slideToNext = () => {
    this.slider.slickNext();
  }

  indexToFeature = () => {
    const { contextURL } = this.props;
    const alias = getUrlAlias(contextURL);
    if (alias) {
      const indexToFeature = FEATURES_SOLUCIONES_INDEX[alias];
      return indexToFeature
    }
    return undefined;
  }


  render() {
    const { iconList } = this.props;
    if (iconList) {
      const {
        page,
        width,
        iconIndex,
        settings,
      } = this.state;


      const arrowsHidden = width < 768;
      const slides = iconList.length;
      const leftArrowVisible = !arrowsHidden && page > 0;
      const rightArrowVisible = !arrowsHidden && page < slides - this.findBreak();

      /* * Se ha creado una funcion para el color del icono y otra para el color del texto para unificarlo con la cabecera principal (home). En caso de que la cabecera cambie a gris podemos quedarnos con una sola función (colorSelectedText y renombrarla a colorSelected) * */
      const colorSelectedIcon = (index) => {
        return iconIndex === index ? 'blue' : '';
      };
      const colorSelectedText = (index) => {
        return iconIndex === index ? 'blue' : 'grey9';
      };

      return (
        <div className="SubHeader">
          <div className="SubHeader__container">
            <div className="scrollSliderGap">
              <Slider ref={(slider) => { this.slider = slider }} {...settings}>
                {iconList.map((component, index) => (
                  <CustomLink
                    taggingInfo={{
                      componentContent: `${component.title}`,
                      componentProduct: '',
                      componentVariation: 'all',
                      componentName: COMPONENT_NAME,
                    }}
                    link={component.link}
                    className="SubHeader__container__link"
                  >
                    <span className="SubHeader__container__wrapper transform">
                      <div className="SubHeader__container__icon">
                        <SvgIconLoader
                          kind={SVG_ICON_KIND.LIGHT}
                          segment={SEGMENT.EMP}
                          backgroundColor={COLOR.TRANSPARENT}
                          size={30}
                          id={component.icon}
                          className="icon-transform"
                          color={colorSelectedIcon(index)}
                        />
                      </div>
                      <div className="SubHeader__container__title">
                        <TextInfo
                          align={ALIGN.CENTER}
                          size={SIZE.CAPTION1}
                          fontType={FONT_TYPE.REGULAR}
                          text={component.title}
                          segment={SEGMENT.EMP}
                          className={iconIndex === index ? '' : 'title-transform'}
                          color={colorSelectedText(index)}
                        />
                      </div>
                    </span>
                  </CustomLink>
                ))}
              </Slider>

            </div>
          </div>
          <Arrow
            kind={CHEURON_TYPES.LEFT}
            onClick={leftArrowVisible ? this.slideToPrev : null}
            visible={leftArrowVisible}
            taggingInfo={{ debug: true }}
            page2go={page}
            iconProps={
                  {
                    id: 'CircleCheuron',
                    kind: CHEURON_TYPES.LEFT,
                    color: 'grey4',
                    size: 12,
                  }
                }
            size="small"
            opacity={1}
          />
          <Arrow
            kind={CHEURON_TYPES.RIGHT}
            onClick={rightArrowVisible ? this.slideToNext : null}
            visible={rightArrowVisible}
            taggingInfo={{ debug: true }}
            page2go={page}
            iconProps={
                  {
                    id: 'CircleCheuron',
                    kind: CHEURON_TYPES.RIGHT,
                    color: 'grey4',
                    size: 12,
                  }}
            size="small"
            opacity={1}
          />
        </div>
      )
    }
    return null;
  }
}

const mapStateToProps = state => ({
  contextURL: state.router.location.pathname,
});

export default connect(mapStateToProps, null)(SubHeader);
